import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme
} from '@mui/material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import HomeIcon from '@mui/icons-material/Home';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const SIDEBAR_WIDTH = 274;
const HEADER_HEIGHT = 65;


const navigationItems = [
  { text: "Home", icon: HomeIcon, path: "/", active: true },
  { text: "CVs", icon: DescriptionIcon, path: "/cvs" },
  { text: "Files & Media", icon: CloudUploadIcon, path: "/uploaded-files" },
];

const Sidebar = ({ currentPath }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const handleNavigation = (path) => {
    navigate(path);
  };


  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: theme.palette.background.paper,
        borderRight: 'none',
        boxShadow: '0px 2px 1px -1px #00000033, 0px 1px 1px 0px #00000024, 0px 1px 3px 0px #0000001F',
        overflowY: 'auto',
        position: 'fixed',
        left: 0,
        top: `${HEADER_HEIGHT}px`,
        zIndex: 1000,
      }}

    >

      <List sx={{ padding: '8px' }}>
        {navigationItems.map((item) => (
          <ListItem
            key={item.text}
            onClick={() => handleNavigation(item.path)}
            sx={{
              cursor: 'pointer',
              width: '258px',
              height: '40px',
              padding: '8px 16px',
              margin: 0,
              marginBottom: '8px',
              borderRadius: '4px',
              gap: '8px',
              backgroundColor: item.active ? theme.palette.grey[400] : 'transparent',
              color: item.active ? '#000000' : theme.palette.grey[500],
              '&:hover': {
                backgroundColor: theme.palette.grey[400],
                color: '#000000',
                '& .MuiListItemIcon-root .MuiSvgIcon-root': {
                  color: '#000000',
                },
              },
              '& .MuiListItemIcon-root .MuiSvgIcon-root': {
                color: item.active ? theme.palette.grey[500] : theme.palette.grey[500],
              },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ListItemIcon sx={{
              minWidth: '24px',
              width: '24px',
              height: '24px',
              marginRight: '8px'
            }}>
              <item.icon
                sx={{
                  fontSize: '24px',
                  width: '24px',
                  height: '24px',
                }}
              />

            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;